import { useState } from "react";
import { ZoomIn } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Lightbox } from "@/components/Lightbox";
import { ImageDisclaimer } from "@/components/ImageDisclaimer";

const IMG = { src: "/brochure/site-plan-plots.png", alt: "Central Plaza complete site plan — plot layout, road width and entry-exit" };

export const SitePlan = () => {
  const [open, setOpen] = useState(false);
  return (
    <section id="site-plan" className="cp-section cp-section--cream" data-testid="site-plan-section">
      <div className="cp-container">
        <Reveal className="cp-section-head">
          <span className="cp-eyebrow">Site Plan</span>
          <h2 className="cp-h2">Plot Layout, Road Width &amp; Entry–Exit</h2>
          <p className="cp-section-desc">
            Sixteen SCO plots arranged around a central landscaped plaza, framed by a 45-meter
            sector road and 12-meter service road for effortless access.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="cp-siteplan-frame" onClick={() => setOpen(true)} data-testid="site-plan-zoom-trigger">
          <img src={IMG.src} alt={IMG.alt} loading="lazy" />
          <span className="cp-zoom-hint">
            <ZoomIn size={16} /> Click to Zoom
          </span>
        </Reveal>
        <ImageDisclaimer />
      </div>

      {open && (
        <Lightbox
          images={[IMG]}
          index={0}
          onClose={() => setOpen(false)}
          onPrev={() => {}}
          onNext={() => {}}
        />
      )}
    </section>
  );
};
